module.exports = __webpack_public_path__ + "nc_static/media/data_analysis.42c9de1f.svg";